import {generateAsyncActionCreators} from '../core/reduxUtils';

const getFooterItemsActionCreators = generateAsyncActionCreators(
  'GET_FOOTER_ITEMS',
  (params) => ({params})
);

const actionCreators = {
  getFooterItems: {
    ...getFooterItemsActionCreators
  }
};

export {
  actionCreators,
  getFooterItemsActionCreators
};
